import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo0",
  "use": "icon-icon-todo0-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo0\"><path d=\"M479.925 554.58v-42.66H383.94v-63.99h82.732l-84.026-84.026 45.248-45.248 84.026 84.026 84.026-84.026 45.248 45.248-84.026 84.026H639.9v63.99h-95.985v42.66H639.9v63.99h-95.985v85.32h-63.99v-85.32H383.94v-63.99h95.985zM597.24 853.2v63.99H202.635c-53.011 0-95.985-42.974-95.985-95.985v-618.57c0-53.011 42.974-95.985 95.985-95.985h618.57c53.011 0 95.985 42.974 95.985 95.985V597.24H853.2V202.635c0-17.67-14.325-31.995-31.995-31.995h-618.57c-17.67 0-31.995 14.325-31.995 31.995v618.57c0 17.67 14.325 31.995 31.995 31.995H597.24z m213.3-183.026l59.324 83.054 89.986-74.989V895.86c0 35.34-28.65 63.99-63.99 63.99H725.22c-35.34 0-63.99-28.65-63.99-63.99V678.24l89.986 74.988 59.324-83.054z m-47.326 176.348l-37.994-31.661v80.999h170.64v-81l-37.994 31.662-47.326-66.256-47.326 66.256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo0.svg
// module id = Ooql
// module chunks = 3